import { render, staticRenderFns } from "./Simplecontent.vue?vue&type=template&id=126e003f&scoped=true&"
import script from "./Simplecontent.vue?vue&type=script&lang=js&"
export * from "./Simplecontent.vue?vue&type=script&lang=js&"
import style0 from "./Simplecontent.vue?vue&type=style&index=0&id=126e003f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e003f",
  null
  
)

export default component.exports